export default __webpack_public_path__ + "static/media/i039sk.64471e63.webp";